<template>
	<v-row>
		<v-col cols="12">
			<package-card :payments="numOfPayments" :cPackage="cPackage"/>
		</v-col>
		<v-col>
			<message-box v-if="errorMessage" :message="errorMessage"/>
			<v-row>
				<v-col>
					<v-select required :items="paymentTypeItems" v-model="paymentType"
						label="הוראת קבע/חד פעמי"></v-select>
				</v-col>
				<v-col>
					<v-select required :items="numOfPaymentsItems" v-model="numOfPayments"
						label="מספר תשלומים"></v-select>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<loader v-if="inProgress"/>
					<iframe ref="nIframe" @load="postNedarim({'Name':'GetHeight'})"
						style="width:100%;-webkit-box-sizing:border-box;height:0px;border:1px solid indianred;"
						scrolling="no" src="https://matara.pro/nedarimplus/iframe"></iframe>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-btn v-if="showBtn" :loading="inProgress" :disabled="inProgress" type="button" color="success"
						@click="payClick">שלח טופס!
					</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
	import Loader from "../components/loader";
	import PackageCard from "../views/packages/PackageCard";

	export default {
		name: "nedarimplus-iframe",
		components: {PackageCard, Loader},
		props: {client: Object, amount: Number, cPackage: Object},
		data() {
			return {
				errorMessage: null,
				inProgress: true,
				showBtn: true,
				numOfPayments: 0,
				paymentType: "Ragil",
				paymentTypeItems: [
					{text: "חד פעמי - תופס מסגרת", value: "Ragil"},
					{text: "הוראת קבע - לא תופס מסגרת אשראי", value: "HK"}
				],
			};
		},
		computed: {
			numOfPaymentsItems() {
				let items = [];
				for (let i = 0; i < this.cPackage.num_of_payments; i++) {
					items.push(i + 1);
				}
				return items;
			},
			lottery() {
				return this.$store.state.LotteryModule.lottery;
			},
			price() {
			    return this.paymentType === "Ragil" ?
                    this.package.price :
				    this.package.price / this.numOfPayments;
			},
			package() {
				return this.$store.state.PackageModule.package;
			}
		},
		methods: {
			ReadPostMessage(event) {
				switch (event.data.Name) {
				case "Height":
					//Here you get the height of iframe | event.data.Value
					this.$refs.nIframe.style.height = (parseInt(event.data.Value) + 15) + "px";
					break;

				case "TransactionResponse":

					if (event.data.Value.Status === "Error") {
						this.inProgress = false;
						this.showBtn = true;
						this.errorMessage = event.data.Value.Message;
						// this.$emit("success",event.data.Value);


					} else {
						this.inProgress = true;
						this.$emit("success", event.data.Value);
					}
				}
			},
			postNedarim(data) {
				this.inProgress = false;
				this.$refs.nIframe.contentWindow.postMessage(data, "*");
			},
			payClick() {
			    debugger;
				this.showBtn = false;
				let data = {
					"Name": "FinishTransaction2",
					"Value": {
						// "Mosad": 0,
						// "ApiValid": "j+iyEFN3bE",
						"Mosad": 7001566,
						"ApiValid": "rESLT6Gaw7",
						"PaymentType": this.paymentType,
						"Currency": "1",

						"Zeout": this.client.id_number,
						"FirstName": this.client.name,
						"LastName": "",
						"Street": "",
						"City": "",
						"Phone": this.client.tel,
						"Mail": this.client.email,
						"Amount": this.price,
						"Tashlumim": this.numOfPayments,

						"Groupe": "",
						"Comment": "ישיבה על קברו",

						"CallBack": document.location.origin + "/api/transaction",

						// 'Tokef': document.getElementById('Tokef').value //אם אתם מנהלים את התוקף בדף שלכם (מיועד למי שרוצה להפריד בין חודש לשנה ורוצה לעצב מותאם אישית)

					}
				};
				this.postNedarim(data);
			}
		},
		mounted() {
			window.addEventListener("message", this.ReadPostMessage, false);
		},
		created() {
			this.numOfPayments = this.cPackage.num_of_payments;
		},
		destroy() {
			window.removeEventListener("message", this.ReadPostMessage, false);

		}

	};
</script>

